'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var plugin = require('tailwindcss/plugin');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var plugin__default = /*#__PURE__*/_interopDefaultCompat(plugin);

// Utility to add gradient masks
var gradientMask = plugin__default.default(({ addUtilities, theme })=>{
    const placements = {
        t: 'top',
        b: 'bottom',
        tb: 'both',
        none: 'none'
    };
    const sizes = [
        {
            key: 'sm',
            // @ts-expect-error should be fixed
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            value: theme('spacing')['12']
        },
        {
            key: 'base',
            // @ts-expect-error should be fixed
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            value: theme('spacing')['20']
        }
    ];
    const getGradientMask = (shorthand, direction, size)=>{
        const className = `.gradient-mask-${shorthand}-${size.key}`;
        let maskImageContent = 'none';
        if (direction === 'top') {
            maskImageContent = `linear-gradient(transparent, black ${size.value}, black calc(100% - ${size.value}))`;
        } else if (direction === 'bottom') {
            maskImageContent = `linear-gradient(black ${size.value}, black calc(100% - ${size.value}), transparent)`;
        } else if (direction === 'both') {
            maskImageContent = `linear-gradient(transparent, black ${size.value}, black calc(100% - ${size.value}), transparent)`;
        }
        return {
            [className]: {
                maskImage: maskImageContent
            }
        };
    };
    const gradientMasks = Object.entries(placements).reduce((result, [shorthand, direction])=>{
        const variants = sizes.map((size)=>getGradientMask(shorthand, direction, size));
        // @ts-expect-error should be fixed
        const stepClasses = Object.assign(...variants);
        return {
            ...result,
            ...stepClasses
        };
    }, {});
    addUtilities(gradientMasks);
});

exports.default = gradientMask;
//# sourceMappingURL=gradientMask.js.map
